import React from 'react'
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import KeySharp from '@mui/icons-material/KeySharp';

export function SENHA(props) {
    if (props.steps === 1) {
        return (
            <>
                <div className='text-2xl'>Insira a senha</div>
                <TextField
                    onKeyDown={props.handleEnter}
                    value={props.senha}
                    onChange={(e) => props.setSenha(e.target.value)}
                    required
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <KeySharp color='primary' />
                            </InputAdornment>
                        ),
                    }}
                    className={props.styles.Senha}
                    id="outlined-password-input senha"
                    label="Senha"
                    type="password"
                    autoComplete="current-password"
                    focused
                    variant="standard"
                />
            </>
        )
    }
    else {
        return <></>;
    }
}
